import apiService from "./apiService";

const ITEM_PER_PAGE = 10;

const requestBannerList = (page = 1, screen = "HOME", itemPerPage = ITEM_PER_PAGE) => {
  const params = {
    page: page,
    item_per_page: itemPerPage
  };
  return apiService.get(URIS_D('banners', screen), {params});
};

const requestCreateBanner = (bannerTypeId, payload) => {
  return apiService.post(URIS_D('toggleBanner', bannerTypeId), payload);
};

const requestToggleBanner = (pageId, togglePayload) => {
  return apiService.patch(URIS_D("bannerTypeBanners", pageId, togglePayload.banner_id), togglePayload);
};


const requestDeleteBanner = (bannerId) => {
  return apiService.delete(URIS_D("removeBanner", bannerId));
};

const requestRearrangeBanners = (pageId, bannerId, payload) => {
  return apiService.patch(URIS_D("activeBanner", pageId, bannerId), payload);
};

const requestUpdateBanner = (bannerTypeId, bannerId, payload) => {
  return apiService.put(URIS_D("editBanner", bannerTypeId, bannerId), payload);
};

const requestBannerPages = () => {
  return apiService.get(URIS.banners);
};

const requestFeaturedBanners = (type, screen) => {
  const params = {
    type, screen
  };

  return apiService.get(URIS.featuredBanners, {params});
};

const requestCreateBannerType = (payload) => {
  return apiService.post(URIS.banners, payload);
};

const getAllBannersByType = (bannerTypeId) => {
  return apiService.get(URIS_D('customerBanners', bannerTypeId));
};

const requestBannersByType = (bannerTypeId, page = 1, itemPerPage = ITEM_PER_PAGE) => {
  const params = {
    page: page,
    item_per_page: itemPerPage
  };
  return apiService.get(URIS_D('toggleBanner', bannerTypeId), {params});
};

const requestDeleteBannerType = (bannerTypeId) => {
  return apiService.delete(URIS_D('removeBannerType', bannerTypeId));
};

const putBannerType = (bannerTypeId, payload) => {
  return apiService.put(URIS_D('removeBannerType', bannerTypeId), payload)
}




export {
  requestBannerList,
  requestCreateBanner,
  requestToggleBanner,
  requestDeleteBanner,
  requestRearrangeBanners,
  requestUpdateBanner,
  requestBannerPages,
  requestFeaturedBanners,
  requestCreateBannerType,
  requestBannersByType,
  requestDeleteBannerType,
  getAllBannersByType,
  putBannerType
};

const URIS_D = (url, param1, param2 = "") => {
  return {
    banners: `${URIS.banners}?screen=${param1}`,
    banner: `${URIS.banners}/${param1}`,
    activeBanner: `${URIS.banners}/${param1}/active-banners/${param2}`,
    toggleBanner: `${URIS.banners}/${param1}/banners`,
    bannerTypeBanners: `${URIS.banners}/${param1}/banners/${param2}`,
    removeBanner: `/v1/cms/banners/${param1}`,
    removeBannerType: `${URIS.banners}/${param1}`,
    editBanner: `${URIS.banners}/${param1}/banners/${param2}`,
    customerBanners: `${URIS.customerBannerTypes}/${param1}/banners`
  }[url];
};

const URIS = {
  banners: '/v1/cms/banner-types',
  customerBannerTypes: '/v1/banner-types',
  activeBanners: '/v1/cms/active-banners',
  featuredBanners: `/v1/featured-banners`
};
